/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationDetailForAzureSubscription extends models.BillingInformationBase {
    constructor() {
        super();
        this.setDiscriminator("BillingInformationDetailForAzureSubscription");
    }

    getFixupPrototypeFunction() { return BillingInformationDetailForAzureSubscription.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationDetailForAzureSubscription>): BillingInformationDetailForAzureSubscription {
        let obj = Object.assign(new BillingInformationDetailForAzureSubscription(), model);
        BillingInformationDetailForAzureSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationDetailForAzureSubscription>): BillingInformationDetailForAzureSubscription {
        if (!model) return null;
        return BillingInformationDetailForAzureSubscription.newInstance(<BillingInformationDetailForAzureSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationDetailForAzureSubscription) {
        if (!obj) return;

        models.BillingInformationDetailForAzureSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationDetailForAzureSubscription): boolean {
        if (models.BillingInformationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationDetailForAzureSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.billing_periods) {
            for (let val of this.billing_periods) {
                models.BillingInformationForAzureSubscription.fixupPrototype(val);
            }
        }
    }

    /**
     * Details for the billing period.
     */
    billing_periods: Array<models.BillingInformationForAzureSubscription>;

}
